import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chat",
  "use": "icon-chat-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 512 512\" id=\"icon-chat\">\r\n<g>\r\n\t<g>\r\n\t\t<g>\r\n\t\t\t<path d=\"M432,0H80C35.817,0,0,35.817,0,80v256c0,44.183,35.817,80,80,80h313.44l91.2,91.36c3.02,2.995,7.107,4.665,11.36,4.64\r\n\t\t\t\tc8.837,0,16-7.163,16-16V80C512,35.817,476.183,0,432,0z M480,457.44l-68.64-68.8c-3.019-2.995-7.107-4.665-11.36-4.64H80\r\n\t\t\t\tc-26.51,0-48-21.49-48-48V80c0-26.51,21.49-48,48-48h352c26.51,0,48,21.49,48,48V457.44z\" />\r\n\t\t\t<circle cx=\"256\" cy=\"208\" r=\"32\" />\r\n\t\t\t<circle cx=\"368\" cy=\"208\" r=\"32\" />\r\n\t\t\t<circle cx=\"144\" cy=\"208\" r=\"32\" />\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chat.svg
// module id = VxLz
// module chunks = 11